module.exports = __webpack_public_path__ + "img/quarter-game-plan.4be97034.png";